export const FEDEX_TRACKING_FORMAT_WARNING =
  "Tracking number does not match the FedEx format.";

export const UPS_TRACKING_FORMAT_WARNING =
  "Tracking number does not match the UPS format.";

export const FEDEX_TRACKING_FORMAT_VERIFIED =
  "Verified FedEx tracking number.";

export const UPS_TRACKING_FORMAT_VERIFIED =
  "Verified UPS tracking number.";

export type TrackingNumberFormatStatus = "idle" | "valid" | "invalid";

export type TrackingNumberFormatFeedback = {
  status: TrackingNumberFormatStatus;
  message: string | null;
};

const FEDEX_PATTERNS = [
  /^\d{6,22}$/,
  /^DT\d{12}$/,
];

// UPS formats from ups.com tracking support:
// standard 1Z / 12-digit / T+10 / 9-digit; other types 7-20 characters;
// Mail Innovations: 22-34 digit USPS DC, 18-digit MMS/MMI, MI + 6-digit customer + up to 22 alphanumeric.
const UPS_PATTERNS = [
  /^1Z[A-Z0-9]{16}$/,
  // /^\d{12}$/,
  /^T\d{10}$/,
  // /^\d{9}$/,
  // /^[A-Z0-9]{7,20}$/,
  // /^\d{22,34}$/,
  // /^\d{18}$/,
  // /^MI\d{6}[A-Z0-9]{1,22}$/,
];

export function normalizeTrackingNumber(value?: string | null): string {
  if (value == null || typeof value !== "string") return "";
  return value.replace(/[\s-]/g, "").toUpperCase();
}

export function extractCarrierFromShippingMethod(shippingMethod?: string | null): string {
  if (!shippingMethod || typeof shippingMethod !== "string") return "";
  const prefix = shippingMethod.split(" - ")[0]?.trim().toUpperCase() || "";
  if (prefix.startsWith("FEDEX") || prefix.startsWith("FED EX") || prefix.startsWith("FED-EX")) {
    return "FEDEX";
  }
  if (prefix.startsWith("UPS")) {
    return "UPS";
  }
  return prefix;
}

export function getTrackingNumberFormatFeedback(
  trackingNumber?: string | null,
  shippingMethod?: string | null
): TrackingNumberFormatFeedback {
  const normalized = normalizeTrackingNumber(trackingNumber);
  if (!normalized) {
    return { status: "idle", message: null };
  }

  const carrier = extractCarrierFromShippingMethod(shippingMethod);
  if (carrier === "FEDEX") {
    return FEDEX_PATTERNS.some((pattern) => pattern.test(normalized))
      ? { status: "valid", message: FEDEX_TRACKING_FORMAT_VERIFIED }
      : { status: "invalid", message: FEDEX_TRACKING_FORMAT_WARNING };
  }
  if (carrier === "UPS") {
    return UPS_PATTERNS.some((pattern) => pattern.test(normalized))
      ? { status: "valid", message: UPS_TRACKING_FORMAT_VERIFIED }
      : { status: "invalid", message: UPS_TRACKING_FORMAT_WARNING };
  }
  return { status: "idle", message: null };
}

export function validateTrackingNumberForShippingMethod(
  trackingNumber?: string | null,
  shippingMethod?: string | null
): true | string {
  const feedback = getTrackingNumberFormatFeedback(trackingNumber, shippingMethod);
  return feedback.status === "invalid" ? feedback.message || true : true;
}
